// extracted by mini-css-extract-plugin
export var compactFilters = "_er-4";
export var detailImage = "_er-1";
export var dropdownContainer = "_er-2";
export var imageContainer = "_er-0";
export var selectedCard = "_er-3";